class Constant {
    static get APP_CODE () {
      return '10004'
    }
    static get PRIMARY_KEY () {
      return 'CE0BFD15059B68D67688884D7A3D3E0C'
    }
    static get PAGE_SIZE () {
      return 20
    }
    static get PAGE_SIZE_200 () {
      return 200
    }
  }
  
  export default Constant


// WEBPACK FOOTER //
// ./src/constants/constant.js